import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

import Table from "../NewTable";
import Collapse from "../Collapse";

import { ReactComponent as HistoryIcon } from "../../assets/images/history-icon.svg";

import "./style.scss";

const History = ({ data }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";

  const statuses = useSelector(
    (store) => store.theme.WorkflowStatus.item.Items
  );

  const columns = [
    {
      key: "Status",
      cell: (item) => {
        const statusObj = statuses?.find(
          (e) => e?.Value?.toString() === item?.Status?.toString()
        );

        return isAr ? statusObj?.Arabic : statusObj?.English;
      },
      header: intl.formatMessage({
        id: "history.status",
      }),
      width: "20%",
    },
    {
      key: "Creator",
      cell: (item) => item?.ActionByModel?.DisplayName || "---",
      header: intl.formatMessage({
        id: "history.creator",
      }),
      width: "20%",
    },
    {
      key: "ActionDate",
      cell: (item) => {
        return item?.ActionDate ? item?.ActionDate : "---";
      },
      header: intl.formatMessage({ id: "history.action-date" }),
      width: "20%",
    },
    {
      key: "ActionTime",
      cell: (item) => (item?.ActionTime ? item?.ActionTime : "---"),
      header: intl.formatMessage({
        id: "history.action-time",
      }),
      width: "20%",
    },
    {
      key: "Comments",
      cell: (item) => item?.Comment,
      header: intl.formatMessage({
        id: "history.comments",
      }),
      width: "20%",
    },
  ];

  return (
    <Collapse
      defaultExpanded
      title={intl.formatMessage({
        id: "common.history",
      })}
      icon={<HistoryIcon />}
    >
      <Table data={data} columns={columns} headerHasBackgroundColor />
    </Collapse>
  );
};

export default History;
